import styled from 'styled-components';

const AttentionChannelsContainerStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #c9cfd7;
  background: #fff;

  @media (min-width: 769px) {
    grid-template-columns: auto auto;
  }
`;

export default AttentionChannelsContainerStyled;
